var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin-top":"86px"}},[_c('HomeImage'),_c('HomeBody')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }